import TripTravelerInformationContainer from './tripTravelerInformationContainer'

export default TripTravelerInformationContainer